// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"669":"591a3a6f","776":"53a7f30c"}[chunkId] + ".chunk.js";
};